import axios from 'axios';
import config from '../config';
import httpArcheo from "../helpers/http-archeo";



export const getCassette = async (filter) => {
  let path = `/api/private/v3/cassetta/get?`;
  filter.forEach((f) => {
    if(f.value) path += `${f.key}=${f.value}&`;
  });
  try {
    const response = await httpArcheo.get(path);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getCassetta = async (id) => {
  let path = `/api/private/v3/cassetta/get/${id}`;
  try {
    const response = await httpArcheo.get(path);
    return response?.data?.cassetta;
  } catch (err) {
    throw err;
  }
};

export const createCassetta = async (data) => {
  try {
    const response = await httpArcheo.post(`/api/private/v3/cassetta/save`, data);
    return response?.data;
  } catch (err) {
    throw err;
  }
};


export const updateCassetta = async (data) => {
  try {
    const response = await httpArcheo.put(`/api/private/v3/cassetta/update`, data);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const deleteCassetta = async (id) => {
  try {
    const response = await httpArcheo.delete(`/api/private/v3/cassetta/delete/${id}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};